import './Theme.Page.Static.1.scss';
export default `ThemePageStatic1`;
